import { Checkbox } from '@/components/ui/checkbox';

interface ShowArchivedToggleProps {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

/**
 * The "Show archived" switch of a project filter over recorded hours. Off by
 * default, so the list holds active projects only; on, it adds the archived
 * and on-hold ones (`withArchivedHidden`, `lib/archived-projects.ts`). [HW-951]
 */
export function ShowArchivedToggle({ id, checked, onCheckedChange }: ShowArchivedToggleProps) {
  return (
    <label
      htmlFor={id}
      className="flex cursor-pointer select-none items-center gap-1.5 text-xs text-muted-foreground"
    >
      <Checkbox id={id} checked={checked} onCheckedChange={(next) => onCheckedChange(next === true)} />
      Show archived
    </label>
  );
}
